import React from "react";
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	CardTitle,
	Row,
	Col
} from "reactstrap";
import moment from "moment";
import { Link } from "react-router-dom";

// Requests
import { getCommissionRequest } from '../../api/commissions';
// Helpers
import { formatPaymentSubtype } from "helpers/payment";
import { formatPaymentStatus } from "helpers/status";
import { formatPrice } from "helpers/pricing";

class CommissionDetails extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			commission: null,
		}
	}

	async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			const commissionObj = await getCommissionRequest(id);

            this.setState({ 
				commission: commissionObj,
            })
		} else {
			this.goTo('/commissions')
		}
	}

    goTo = path => this.props.history.push(path);

	toggleNewEntry = (value) => {
		this.setState({
		  addingEntry: value
		})
	}

    render() {

		const {
			commission
		} = this.state;

		const {
			_id,
			commissionable_amount,
			cleared_percentage,
			amount,
			amount_net_due,
			vat_amount,
			withholding_tax,
			currency,
			status,
			client,
			recipientType,
			recipientId,
			project,
			unit,
			payment,
			due_date,
			settled_date,
			check_number,
			date_received,
			or_number,
			created_at,
			updated_at
		} = commission || {};

        return(
            <>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader className="mb-5">
                                    <CardTitle tag="h3">Commission Details</CardTitle>
                                    <Button
										className="float-right"
										color="default"
										onClick={() => this.goTo('/commissions')}
									>
										Back
                  					</Button>
                                </CardHeader>
                                <CardBody>
									{
										!commission ? 
											<div>Loading...</div>
										:
										<>
											<div className="typography-line">
												<h4>
													<span>ID</span>
													{_id}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Commissionable Amount</span>
													{commissionable_amount ? `${currency || 'PHP'} ${formatPrice(commissionable_amount)}` : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Cleared Percentage</span>
													{cleared_percentage ? `${(cleared_percentage * 100).toFixed(2)}%` : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Amount</span>
													{amount ? `${currency || 'PHP'} ${formatPrice(amount)}` : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>VAT</span>
													{vat_amount ? `${currency || 'PHP'} ${formatPrice(vat_amount)}` : "0"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Withholding Tax</span>
													{withholding_tax ? `${currency || 'PHP'} ${formatPrice(withholding_tax)}` : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Net Due</span>
													{amount_net_due ? `${currency || 'PHP'} ${formatPrice(amount_net_due)}` : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Check #</span>
													{check_number || "N/A"}
												</h4>
											</div>

											{!!check_number ? <div className="typography-line">
												<h4>
													<span>Date Received</span>
													{date_received ? moment(date_received).format("MM/DD/YYYY") : "N/A"}
												</h4>
											</div> : null}

											<div className="typography-line">
												<h4>
													<span>OR #</span>
													{or_number || "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Status</span>
													{status ? formatPaymentStatus(status) : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Client</span>
													{client ? 
														<Link to={`/client?id=${client._id}`}>
															{`${client.first_name} ${client.last_name}`}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Recipient Type</span>
													{recipientType ? recipientType.charAt(0).toUpperCase() + recipientType.slice(1) : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Recipient</span>
													{recipientId && recipientType ? 
														<Link to={`/${recipientType}?id=${recipientId._id}`}>
															{recipientType === 'broker' 
																? recipientId.name 
																: `${recipientId.first_name} ${recipientId.last_name}`
															}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Project</span>
													{project ? 
														<Link to={`/project?id=${project._id}`}>
															{project.name}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Unit</span>
													{unit ? 
														<Link to={`/unit?id=${unit._id}`}>
															{unit.block_number && unit.lot_number 
																? `Block ${unit.block_number}, Lot ${unit.lot_number}`
																: unit.lot_number || unit.block_number || unit._id
															}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Related Payment</span>
													{payment ? 
														<Link to={`/payment?id=${payment._id}`}>
															{payment.subtype ? `${formatPaymentSubtype(payment.subtype)} - ${formatPrice(payment.amount)}` : payment._id}
														</Link>
													:
														"N/A"
													}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Due Date</span>
													{due_date ? moment(due_date).format("MM/DD/YYYY") : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Settled Date</span>
													{settled_date ? moment(settled_date).format("MM/DD/YYYY") : "N/A"}
												</h4>
											</div>

											<div className="typography-line">
												<h4>
													<span>Created At</span>
													{created_at ? moment(created_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
												</h4>
											</div>
											<div className="typography-line">
												<h4>
													<span>Updated At</span>
													{updated_at ? moment(updated_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
												</h4>
											</div>
										</>
									}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>


                </div>
            </>
        )
    }
}

export default CommissionDetails;